module.exports = __webpack_public_path__ + "img/Frame.948f1bf7.svg";